import script from "./ModalClasificacionEvento.vue?vue&type=script&lang=ts&setup=true"
export * from "./ModalClasificacionEvento.vue?vue&type=script&lang=ts&setup=true"

import "./ModalClasificacionEvento.vue?vue&type=style&index=0&id=1d566a65&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d566a65"]])

export default __exports__